// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gengar: PokeData = {
  "id": 94,
  "name": "gengar",
  "height": 15,
  "weight": 405,
  "base_experience": 225,
  "types": [
    PokeType.GHOST,
    PokeType.POISON
  ],
  "api_moves": [
    "disable",
    "toxic",
    "hypnosis",
    "night-shade",
    "confuse-ray",
    "haze",
    "lick",
    "smog",
    "dream-eater",
    "poison-gas",
    "nightmare",
    "curse",
    "spite",
    "destiny-bond",
    "perish-song",
    "mean-look",
    "shadow-ball",
    "will-o-wisp",
    "astonish",
    "shadow-punch",
    "payback",
    "sucker-punch",
    "dark-pulse",
    "venoshock",
    "hex",
    "reflect-type"
  ],
  "moves": [
    "night-shade",
    "confuse-ray",
    "lick",
    "poison-gas",
    "curse",
    "shadow-ball",
    "dark-pulse",
    "venom-drench",
    "poison-powder",
    "acid",
    "sludge-bomb",
    "toxic-overload",
    "purify"
  ],
  "evolution_chain": {
    "id": 40,
    "item": null,
    "species": [
      {
        "name": "gastly",
        "order": 100,
        "types": [
          PokeType.GHOST,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "haunter",
        "order": 101,
        "types": [
          PokeType.GHOST,
          PokeType.POISON
        ],
        "evolves_from_species_id": 92,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gengar",
        "order": 102,
        "types": [
          PokeType.GHOST,
          PokeType.POISON
        ],
        "evolves_from_species_id": 93,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 84,
    "speed": 145,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
